import React, { Component } from 'react';
import {Design, NumberCount} from './specilizing/index';

class Specilizing extends Component {
    constructor(props){
        super(props);
        this.state = {
            design : [
                {
                    id: 1,
                    iconbox: 'iconbox-s1 d-sm-flex align-items-center',
                    iconcolor: 'iconbox-icon color1',
                    spanicon: 'fa fa-html5',
                    title: 'HTML',
                    text01: "Excellent knowledge of HTML5",
                    text02: "sematic tags, elements, headings, tables, forms and the DOM and more..."
                },
                {
                    id: 2,
                    iconbox: 'iconbox-s1 d-sm-flex justify-content-lg-center align-items-center mgl-iconbox-s1',
                    iconcolor: 'iconbox-icon color2 color1',
                    spanicon: 'fa fa-css3',
                    title: 'CSS3',
                    text01: "I am a creative and talented web designer",
                    text02: "Very good knowledge of responsive layout, flex-box media queries, browser compatibilty and more..."
                },
                {
                    id: 3,
                    iconbox: 'iconbox-s1 d-sm-flex justify-content-lg-end align-items-center mgr-iconbox-s1',
                    iconcolor: 'iconbox-icon color3',
                    spanicon: 'fab fa-js-square',
                    title: 'JavaScript',
                    text01: "Javascript and React.js & JQuery",
                    text02: "Built varius projects, which led me to have a solid understanding of the Javascript Library, also developed during my Just It BootCamp"
                },
                {
                    id: 4,
                    iconbox: 'iconbox-s1 d-sm-flex justify-content-lg-end align-items-center mgr-iconbox-s1',
                    iconcolor: 'iconbox-icon color3',
                    spanicon: 'fa fa-hashtag',
                    title: 'C#',
                    text01: "Previous experience with C#",
                    text02: "I developed a basic understanding of C# language during my 2 months intern with Avanade"
                },
                {
                    id: 5,
                    iconbox: 'iconbox-s1 d-sm-flex justify-content-lg-end align-items-center mgr-iconbox-s1',
                    iconcolor: 'iconbox-icon color3',
                    spanicon: 'fa fa-database',
                    title: 'SQL',
                    text01: "Previous experince with SQL",
                    text02: "Solid understanding of SQL language developed during 2 months intern with Avanade and with Just It bootCamp"
                },
                {
                    id: 6,
                    iconbox: 'iconbox-s1 d-sm-flex justify-content-lg-end align-items-center mgr-iconbox-s1',
                    iconcolor: 'iconbox-icon color3',
                    spanicon: 'fab fa-python',
                    title: 'Python',
                    text01: "Built Python Projects",
                    text02: "Good Understanding of Python language developed during the Just IT BootCamp and practice"
                },
            ]
        }
    }
    render() {
        return (
            <div className="section slide-personal-Intro-third slide-dark bg-white">
                <section className="specilizing-in s1" id="languages">
                    <div className="container">
                        <div className="flat-title">
                            <h2 className="title-section color-d12 animate-element wow delay5 fadeInDown" data-wow-delay="0.5s">I am passionate about</h2>
                        </div>
                        <div className="row position-relative z-index1">
                            {
                                this.state.design.map(data => (
                                    <Design key={data.id} data={data}/>
                                ))
                            }
                            <div className="flat-spacer" data-desktop="0" data-mobile="0" data-smobile="0"></div>
                            <div className="fact">
                                <NumberCount />
                                <div className="btn-contact bg-s1 text-center">
                                    <h4 className="title color-d12">Check up my GitHub</h4>
                                    <a href="https://github.com/sarauras1" className="color-s1 color-d14">https://github.com/sarauras1</a>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div className="featured-post animate-element wow delay5 fadeInRight" data-wow-delay="0.5s">
                        <img src="images/section/09.png" alt="images" />
                    </div>
                </section>
            </div>
        );
    }
}

export default Specilizing;
